import { formatSpec } from '@/modules/utils/storeUtils';
import { useTribalContext } from '@/context/tribal';
import Box from '@/modules/components/Box/Box';
import { TyreData } from '@/types';
import {
  StyledTyreInformationDetailsItem,
  StyledTyreInformationDetailsList,
} from './TyreInformation.styles';
import {
  CTA,
  DesignTokenSizeEnum,
  Image,
  Text,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { LinkText } from '@/styles';

function TyreInformationDetails({ tyre }: { tyre: TyreData }) {
  const { contentManager } = useTribalContext();

  // const {
  //   tyreLabelUrl,
  //   tyreSpecification: {
  //     tradeName,
  //     fuelEfficiencyPerformanceClass,
  //     externalRollingNoise,
  //     wetGripPerformanceClass,
  //     tyreTypeIdentifier,
  //     sizeDesignation: { tyreSizeDesignation } = {},
  //   } = {},
  // } = tyre || {};

  const {
    tyreLabelUrl,
    tyreSpecification: {
      eprelUrl,
      tradeName,
      fuelEfficiencyPerformanceClass,
      wetGripPerformanceClass,
      tyreTypeIdentifier,
      externalRollingNoise,
      snowGripIsSatisfyingMinimumIndexValues,
      iceGripIsSatisfyingMinimumIndexValues,
      production,
      sizeDesignation: {
        loadCapacityIndex,
        speedCategorySymbol,
        tyreSizeDesignation,
      } = {},
    } = {},
  } = tyre || {};

  const details = [
    {
      label: contentManager.get(
        'tyre-information-supplier-name-or-trademark-label'
      ),
      value: tradeName,
    },
    {
      label: contentManager.get('tyre-information-model-identifier-label'),
      value: tyreTypeIdentifier,
    },
    {
      label: contentManager.get('tyre-information-tyre-size-designation-label'),
      value: tyreSizeDesignation,
    },
    {
      label: contentManager.get('tyre-information-load-capacity-index-label'),
      value: loadCapacityIndex,
    },
    {
      label: contentManager.get('tyre-information-speed-category-symbol-label'),
      value: speedCategorySymbol,
    },
    {
      label: contentManager.get('tyre-information-fuel-efficiency-class-label'),
      value: fuelEfficiencyPerformanceClass,
    },
    {
      label: contentManager.get('tyre-information-wet-grip-class-label'),
      value: wetGripPerformanceClass,
    },
    {
      label: contentManager.get(
        'tyre-information-external-rolling-noise-class-label'
      ),
      value: externalRollingNoise?.performanceClass,
    },
    {
      label: contentManager.get(
        'tyre-information-external-rolling-noise-value-label'
      ),
      value: externalRollingNoise?.value,
    },
    {
      label: contentManager.get('tyre-information-snow-tyre-label'),
      value: snowGripIsSatisfyingMinimumIndexValues == undefined ? '-' : snowGripIsSatisfyingMinimumIndexValues ? 'Yes' : 'No',
    },
    {
      label: contentManager.get('tyre-information-ice-grip-tyre-label'),
      value: iceGripIsSatisfyingMinimumIndexValues == undefined ? '-' : iceGripIsSatisfyingMinimumIndexValues ? 'Yes' : 'No',
    },
    {
      label: contentManager.get('tyre-information-production-start-date-label'),
      value: production?.start,
    },
    {
      label: contentManager.get('tyre-information-production-end-date-label'),
      value: production?.end,
    },
  ];

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        mb={DesignTokenSizeEnum.static300}
        gap={DesignTokenSizeEnum.static500}
        b960={{ flexDirection: 'row' }}
      >
        <Box flexGrow="1">
          <Image src={tyreLabelUrl} alt="image" />
        </Box>
        <Box flexGrow="1">
          <StyledTyreInformationDetailsList>
            {details.map((item) => (
              <StyledTyreInformationDetailsItem key={item.label}>
                <Text appearance={TokenTextAppearance.copy100}>
                  {item.label}
                </Text>
                <Text appearance={TokenTextAppearance.copy100}>
                  {formatSpec(item.value, '-')}
                </Text>
              </StyledTyreInformationDetailsItem>
            ))}
          </StyledTyreInformationDetailsList>
        </Box>
      </Box>

      <Box mb={DesignTokenSizeEnum.static500}>
        <Text appearance={TokenTextAppearance.headline200}>
          {contentManager.get('tyre-information-regulation-text')}
        </Text>
      </Box>

      <CTA
        tag="a"
        href={eprelUrl}
        emphasis="tertiary"
        aria-label={contentManager.get(
          'tyre-information-energy-labelling-cta-label'
        )}
        target="_blank"
      >
        <LinkText appearance={TokenTextAppearance.copy200}>
          {contentManager.get('tyre-information-energy-labelling-cta-label') +
            ' >'}
        </LinkText>
      </CTA>
    </>
  );
}

export default TyreInformationDetails;
